import { render, staticRenderFns } from "./LogisticsNotification.vue?vue&type=template&id=c15df3f2&scoped=true&"
import script from "./LogisticsNotification.vue?vue&type=script&lang=js&"
export * from "./LogisticsNotification.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsNotification.vue?vue&type=style&index=0&id=c15df3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15df3f2",
  null
  
)

export default component.exports